import { dataEllipsisCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEllipsisCircle = /*#__PURE__*/createIcon(dataEllipsisCircle)
export default IconEllipsisCircle
